import { FC } from 'react'
import { Button } from '@/components/ui/button'
import { NameDto } from 'api/Common/Types'
import { FormField, FormFieldBlock, FormSelectField } from 'components/Form/FormField'
import { FieldArray, FormikErrors } from 'formik'
import { CircleMinus, CirclePlus } from 'lucide-react'

import { ReferralMaterialsCategoryDetailsFormValues } from './referralMaterialsCategoriesDetailsForm'
import { ReferralMaterialsCategoryFormValues } from './referralMaterialsCategoryForm'

interface Props {
  baseUrlTypes: NameDto[]
  values: ReferralMaterialsCategoryDetailsFormValues
  isEdit?: boolean
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean | undefined
  ) => Promise<void | FormikErrors<ReferralMaterialsCategoryFormValues>>
}

export const ReferralMaterialsCategoryUrlsField: FC<Props> = ({
  values,
  isEdit = true,
  baseUrlTypes,
  setFieldValue,
}) => {
  return (
    <>
      {values.urls.length > 1 && (
        <div className='text-sm text-muted-foreground'>{`Total URLs (${values.urls.length})`}</div>
      )}

      <FieldArray name='urls'>
        {({ push, remove }) => (
          <>
            {values.urls.map((_, index) => {
              return (
                <FormFieldBlock key={index} className='space-y-3'>
                  <FormSelectField
                    name={`urls[${index}].baseUrl`}
                    label='Base URL'
                    options={baseUrlTypes}
                    readOnly={!isEdit}
                    showSearch
                    allowClear
                    storeValueAs='value'
                    onValueChange={(value) => {
                      if (!value) {
                        setFieldValue(`urls[${index}].targetUrl`, '')
                      }
                    }}
                    rightAddon={
                      isEdit ? (
                        <>
                          {index === values.urls.length - 1 && (
                            <Button
                              variant='outline'
                              size='sm'
                              onClick={() => push({ baseUrl: 1, targetUrl: '' })}
                            >
                              <CirclePlus />
                            </Button>
                          )}
                          {values.urls.length > 1 && (
                            <Button size='sm' variant='outline' onClick={() => remove(index)}>
                              <CircleMinus />
                            </Button>
                          )}
                        </>
                      ) : undefined
                    }
                  />

                  <FormField
                    name={`urls[${index}].targetUrl`}
                    label='Target URL'
                    value={values.urls[index].targetUrl ?? ''}
                    readOnly={!isEdit}
                    disabled={!values.urls[index].baseUrl}
                  />
                </FormFieldBlock>
              )
            })}
          </>
        )}
      </FieldArray>
    </>
  )
}
